package di

import navigation.home.address.AddressUiModule
import navigation.home.clients.clientUiModule
import navigation.home.contact.ContactUiModule
import navigation.home.crm.CRMUiModule
import navigation.home.dashboard.dashboardUiModule
import navigation.home.edititinerary.itineraryUiModule
import navigation.home.invoice.invoiceUiModule
import navigation.home.messages.messageModule
import navigation.home.organization.OrganizationUiModule
import navigation.settings.paymentparameter.paymentParameterUiModule
import navigation.home.proposal.proposalUiModule
import navigation.home.request.requestUiModule
import navigation.home.send_message.sendMessageUiModule
import navigation.home.service.serviceUiModule
import navigation.home.suppliers.supplierUiModule
import navigation.home.task.taskUiModule
import navigation.home.travelagents.travelAgentUiModule
import navigation.root.auth.authUiModule
import navigation.root.home.homeModule
import navigation.settings.areas.areaUiModule
import navigation.settings.categories.categoryUiModule
import navigation.settings.countries.countryUiModule
import navigation.settings.currency.currencyUiModule
import navigation.settings.datetime.dateTimeUiModule
import navigation.settings.general.generalUiModule
import navigation.settings.imagegallery.imageGalleryUiModule
import navigation.settings.settingsModule
import navigation.settings.tags.tagUiModule

val uiModule
    get() =
        listOf(
            // UI modules
            homeModule,
            settingsModule,
            dashboardUiModule,
            serviceUiModule,
            proposalUiModule,
            CRMUiModule,
            ContactUiModule,
            OrganizationUiModule,
            AddressUiModule,
            itineraryUiModule,
            requestUiModule,
            travelAgentUiModule,
            supplierUiModule,
            clientUiModule,
            taskUiModule,
            authUiModule,
            messageModule,
            paymentParameterUiModule,
            invoiceUiModule,
            sendMessageUiModule,
            categoryUiModule,
            tagUiModule,
            areaUiModule,
            countryUiModule,
            currencyUiModule,
            dateTimeUiModule,
            imageGalleryUiModule,
            generalUiModule,
        )
